'use strict';
var util = require('../util');

module.exports = {
  appVersion: '8.0.0',

  setScrollEnabled: util.actionMapping('setScrollEnabled'),
  setBouncesEnabled: util.actionMapping('setBouncesEnabled'),

  bindPhone: util.actionMapping('bindPhone'),
  pay: util.actionMapping('pay')
};